import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import dateFormat from 'dateformat'
import showIf from 'lib/show-if'
import HtmlContent from 'shared/html-content'
import RegistryAvatar from 'registry/components/registry-avatar'
import { Wave } from 'components/curves'

import css from './guest-registry-header.scss'
import { SectionHeading } from '../../../components/headings'

export default class GuestRegistryHeader extends PureComponent {
  static propTypes = {
    arrivalDate: PropTypes.string,
    note: PropTypes.string,
    photoUrl: PropTypes.string,
    title: PropTypes.string,
  }

  render() {
    const { arrivalDate, photoUrl, note, title } = this.props

    const formattedNote = note ? `${note.split('\n').join('</p><p>')}` : null

    return (
      <>
        <div className={css.registryHeaderContainer}>
          <div className="container">
            <SectionHeading className={css.title}>{title}</SectionHeading>

            {showIf(
              arrivalDate,
              <div className={classNames('arrival-date h5', css.date)}>
                {`Arrival Date `}
                <strong>
                  {`${dateFormat(arrivalDate, 'longDate', true)}`}
                </strong>
              </div>
            )}

            <div className={css.note}>
              {showIf(
                formattedNote,
                <HtmlContent html={`<p>${formattedNote}</p>`} />
              )}
            </div>

            {photoUrl && (
              <RegistryAvatar
                className={classNames(css.avatar, 'img-responsive')}
                url={photoUrl}
              />
            )}
          </div>
          <div
            className={classNames(
              css.waveWrapper,
              !photoUrl ? css.noPhoto : null
            )}
          >
            <Wave color="#fff" />
          </div>
        </div>
      </>
    )
  }
}
